module.exports = __webpack_public_path__ + "img/boost_info.bccf8ad2.png";